import cn from 'client/utils/cn';
import LangContext from 'client/utils/lang-context';

import React, { Component } from 'react';

import { PageFinancialsProps } from 'client/bundles/types';

import 'client/components/text-blog/index.css';
import 'client/components/text/index.css';
import './index.css';

import Breadcrumbs from 'client/components/breadcrumbs';
import Date from 'client/components/date';
import DocsList from 'client/components/docs-list';
import TextNoData from 'client/components/text-no-data';

const b = cn('financial');
const bPageTitle = cn('page-title');

interface Props extends Omit<PageFinancialsProps, 'years'> {
    baseUrl: string;
}

class Financial extends Component<Props> {
    static contextType = LangContext;

    render() {
        const { quarterReport, currentYear, baseUrl, title } = this.props;
        const { lang } = this.context;
        const isLangRu = lang === 'ru';

        return (
            <div className={b()}>
                <Breadcrumbs text={title} link={`${baseUrl}?year=${currentYear}`} />

                {
                    quarterReport && quarterReport.html ?
                        (
                            <>
                                <h1 className={bPageTitle()}>{quarterReport.title}</h1>

                                <div className={b('content')}>
                                    <div className={b('content-docs')}>
                                        <DocsList view="line" docs={quarterReport.docs} />
                                    </div>

                                    <div className={b('content-text')}>
                                        <Date dateStart={quarterReport.date} color="black" />

                                        {/* TODO: IR-607 */}
                                        <div
                                            className={b('report',
                                                { 'ru': isLangRu },
                                                ['text', isLangRu ? 'text-blog' : ''])
                                            }
                                            dangerouslySetInnerHTML={{ __html: quarterReport.html }}
                                            />
                                    </div>
                                </div>
                            </>
                        ) :
                            <TextNoData />
                }
            </div>
        );
    }

}

export default Financial;
